import { logSafeErrorWithoutCustomerDataWrapper } from '@jira/polaris__lib-logging/src/logSafeErrorWithoutCustomerDataWrapper.tsx';
import {
	getUserProperty,
	setUserProperties,
} from '@atlassian/jira-common-rest/src/api/latest/user-properties/index.tsx';
import FetchError from '@atlassian/jira-fetch/src/utils/errors.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import { NAV_JPD_VIEWS_SPOTLIGHT_DISMISSED } from './cardCoversSpotlight.constants.tsx';
import type { Props, State } from './GlobalFieldsTourSteps.types.tsx';
import { maybeWaitForPremiumModal } from './maybeWaitForPremiumModal.tsx';

export const loadAllViewsSpotlightDismissed =
	(): Action<State, Props> =>
	async ({ getState, setState }, { accountId }) => {
		if (!accountId) {
			return;
		}

		await maybeWaitForPremiumModal(getState);

		// User property is already loaded
		if (typeof getState().allViews.spotlightDismissed === 'boolean') {
			return;
		}

		try {
			const spotlightDismissed = await getUserProperty<boolean>(
				accountId,
				NAV_JPD_VIEWS_SPOTLIGHT_DISMISSED,
			);

			const state = getState();

			setState({
				...state,
				allViews: {
					...state.allViews,
					spotlightDismissed,
				},
			});
		} catch (error) {
			// Expected error, the property is not set yet
			if (error instanceof FetchError && error.statusCode === 404) {
				const state = getState();

				setState({
					...state,
					allViews: {
						...state.allViews,
						spotlightDismissed: false,
					},
				});

				return;
			}

			logSafeErrorWithoutCustomerDataWrapper(
				'polaris.onboarding.all-views-spotlight',
				`Failed to get user property with key: ${NAV_JPD_VIEWS_SPOTLIGHT_DISMISSED}`,
				error instanceof Error ? error : new Error(String(error)),
			);
		}
	};

export const setAllViewsSpotlightDismissed =
	(): Action<State, Props> =>
	async ({ getState, setState }, { accountId }) => {
		if (!accountId) {
			return;
		}

		const state = getState();

		setState({
			...state,
			allViews: {
				...state.allViews,
				spotlightDismissed: true,
			},
		});

		try {
			await setUserProperties(accountId, NAV_JPD_VIEWS_SPOTLIGHT_DISMISSED, 'true');
		} catch (error) {
			logSafeErrorWithoutCustomerDataWrapper(
				'polaris.onboarding.all-views-spotlight',
				`Failed to set user property with key: ${NAV_JPD_VIEWS_SPOTLIGHT_DISMISSED}`,
				error instanceof Error ? error : new Error(String(error)),
			);
		}
	};
